import React from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { SimpleModal } from "../../../../../../../services/ui-components/src/SimpleModal/SimpleModal";
import { SpinnerLoader } from "@services/ui-components";

export interface ConfirmChangesModalProps {
    show: boolean;
    isSaving?: boolean;
    onClose: () => void;
    onSave: () => void;
    onDontSave: () => void;
}

const ConfirmChangesModal: React.FC<ConfirmChangesModalProps> = ({
    show,
    isSaving = false,
    onClose,
    onSave,
    onDontSave,
}) => {
    const { t } = useTranslation();

    return (
        <SimpleModal
            isOpen={show}
            onClose={onClose}
            title={t("Changes made")}
            description={t("Changes have been made. Save?")}
            className="px-1"
            children={
                <Container>
                    <Row>
                        <Col xs={6} className={"ps-0"}>
                            <Button
                                type="button"
                                variant="outline-primary"
                                className="w-100 fw-normal"
                                onClick={onDontSave}
                                disabled={isSaving}
                            >
                                {t("Cancel")}
                            </Button>
                        </Col>
                        <Col xs={6} className={"ps-0"}>
                            <Button
                                type="button"
                                variant="primary"
                                className="w-100 fw-bold"
                                onClick={onSave}
                                disabled={isSaving}
                            >
                                {isSaving ? <SpinnerLoader variant="light" loadingText={t("Saving...")} /> : t("save")}
                            </Button>
                        </Col>
                    </Row>
                </Container>
            }
        />
    );
};

export default ConfirmChangesModal;
